module.exports = __webpack_public_path__ + "img/bank-banner-bg.0edf22dc.png";